var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgStoreIcons = function SvgStoreIcons(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.531 2.719)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 1.25,
    d: "M4.379 8.156h12.086a2 2 0 0 1 1.966 1.632l1.969 10.5a2 2 0 0 1-1.966 2.368H2.41a2 2 0 0 1-1.966-2.368l1.969-10.5a2 2 0 0 1 1.966-1.632z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.344,
    cy: 11.328,
    r: 1.359,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 11.328,
    r: 1.359,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 1.25,
    d: "M6.356 10.875C6.356 3.915 5.905 0 10.422 0c4.517 0 4.065 3.915 4.065 10.875"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStoreIcons, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/storeIcons.3c54b906.svg";
export { ForwardRef as ReactComponent };